<template>
  <div class="flex items-center mb20">
    <a v-if="path" class="go-back-icon mt2" :href="path"><i class="fal fa-chevron-left"/></a>
    <h3 class="mb0">{{title}}</h3>
    <span v-if="tooltip" class="ml10 cursor-pointer" v-tooltip="tooltip">
      <i class="info-btn fas fa-info-circle" @click="$emit('open')" />
    </span>
    <span v-else class="ml10 cursor-pointer">
      <i class="info-btn fas fa-info-circle" @click="$emit('open')" />
    </span>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    path: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>